import React from 'react';
import Icon from '../../../components/AppIcon';

const EncounterTypeSelector = ({ selectedTypes, onTypeToggle }) => {
  const encounterTypes = [
    {
      id: 'passionate',
      label: 'Passionate',
      icon: 'Flame',
      description: 'Intense and energetic'
    },
    {
      id: 'romantic',
      label: 'Romantic',
      icon: 'Heart',
      description: 'Slow and intimate'
    },
    {
      id: 'playful',
      label: 'Playful',
      icon: 'Smile',
      description: 'Fun and lighthearted'
    },
    {
      id: 'spontaneous',
      label: 'Spontaneous',
      icon: 'Sparkles',
      description: 'Quick and exciting'
    },
    {
      id: 'sensual',
      label: 'Sensual',
      icon: 'Feather',
      description: 'Gentle and exploratory'
    },
    {
      id: 'adventurous',
      label: 'Adventurous',
      icon: 'Compass',
      description: 'Trying something new'
    }
  ];

  const isSelected = (typeId) => selectedTypes?.includes(typeId);

  return (
    <div className="space-y-3">
      <h3 className="text-lg font-heading font-semibold text-foreground">
        Preferred Encounter Type
      </h3>
      <p className="text-sm text-muted-foreground">
        Select one or more types that appeal to you right now
      </p>
      <div className="grid grid-cols-2 md:grid-cols-3 gap-3">
        {encounterTypes?.map((type) => (
          <button
            key={type?.id}
            onClick={() => onTypeToggle(type?.id)}
            className={`
              flex flex-col items-center space-y-2 p-4 rounded-md border-2
              transition-therapeutic
              ${isSelected(type?.id)
                ? 'border-primary bg-primary/5' :'border-border bg-card hover:border-primary/30'
              }
            `}
          >
            <div className={`
              flex items-center justify-center w-12 h-12 rounded-md
              ${isSelected(type?.id) ? 'bg-primary/10' : 'bg-muted'}
            `}>
              <Icon 
                name={type?.icon} 
                size={24} 
                color={isSelected(type?.id) ? 'var(--color-primary)' : 'var(--color-muted-foreground)'}
              />
            </div>
            <div className="text-center">
              <div className="flex items-center justify-center space-x-1 mb-1">
                <span className="text-sm font-medium text-foreground">
                  {type?.label}
                </span>
                {isSelected(type?.id) && (
                  <Icon name="Check" size={14} color="var(--color-primary)" />
                )}
              </div>
              <p className="text-xs text-muted-foreground line-clamp-1">
                {type?.description}
              </p>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};

export default EncounterTypeSelector;